module.exports = __webpack_public_path__ + "index/img/icon_tequan.fe721093.svg";